import React, { useState } from "react";
import styles from "./PlatformGeneratedCoupons.module.scss";
import DynamicCardRow from "../../../DynamicCardRow/DynamicCardRow";
import DynamicTableFilters from "../../../../common/AdminCommonComponents/DynamicTableFilters/DynamicTableFilters";
import DynamicDatatable from "../../../../common/AdminCommonComponents/DynamicDatatable/DynamicDatatable";
import { platformGeneratedTableData } from "../../../../../views/AdminPortal/dummyData";
import StatusBadge from "../../../../common/AdminCommonComponents/StatusBadge/StatusBadge";
import ActionButton from "../../../../common/AdminCommonComponents/Buttons/ActionButton/ActionButton";
import DynamicButton from "../../../../common/AdminCommonComponents/Buttons/DynamicButton/DynamicButton";
import { useNavigate } from "react-router-dom";
import CouponCreationForm from "./CouponCreationForm/CouponCreationForm";

const platformGeneratedCouponsData = [
    { title: "Total active coupons", value: 0 },
    { title: "Pending approvals", value: 0 },
    { title: "Expired coupons", value: 0 },
    { title: "Redemption rates", value: 0 },
    {
        title: "Usage statistics for active coupons",
        value: {
            label: "View Stats",
            isButton: true,
            onClick: () => console.log("View Stats button clicked!")
        }
    },
].map((item) => ({
    ...item,
    title: item.title.toUpperCase(),
}));


const PlatformGeneratedCoupons = () => {
    const [isOpen, setIsOpen] = useState(false);
    const navigate = useNavigate();

    const options = [
        { label: "View details", action: () => navigate("/marketing/coupons/platformcoupondetail") },
        { label: "Edit" },
        { label: "Delete" },
        { label: "Change status" },
    ];

    const columns = [
        {
            name: "ID",
            selector: (_, index) => index + 1,
            center: "true",
            width: "80px",
        },
        {
            name: "Coupon Code",
            selector: (row) => row.couponCode,
            center: "true",
            minWidth: "140px",
        },
        {
            name: "Description",
            selector: (row) => row.description,
            center: "true",
            minWidth: "140px",
        },
        {
            name: "Discount Type",
            selector: (row) => row.discountType,
            center: "true",
            minWidth: "140px",
        },
        {
            name: "Discount Value",
            selector: (row) => row.discountValue,
            center: "true",
            minWidth: "160px",
        },
        {
            name: "Status",
            cell: (row) => <StatusBadge statusName={row.status} />,
            center: "true",
            minWidth: "140px",
        },
        {
            name: "Start Date",
            selector: (row) => row.startDate,
            center: "true",
            minWidth: "140px",
        },
        {
            name: "End Date",
            selector: (row) => row.endDate,
            center: "true",
            minWidth: "140px",
        },
        {
            name: "Actions",
            cell: () => <ActionButton options={options} />,
            center: "true",
        },
    ];

    const handleApply = (filters) => {
        console.log("Applied Filters:", filters);
    };

    const handleClear = () => {
        console.log("Filters Cleared");
    };

    return (
        <div className={styles.platformGeneratedContainer}>
            <div className={styles.overviewWrapper}>
                <h5 className={styles.mainHeading}>Coupon Overview</h5>
                <div className={styles.cardRowWrapper}>
                    <DynamicCardRow cards={platformGeneratedCouponsData} />
                </div>
            </div>

            {!isOpen ? (
                <div className={styles.filterTableWrapper}>
                    <div className={styles.headingBtnWrapper}>
                        <h5 className={styles.sectionHeading}>Platform-Generated Coupons</h5>
                        <div className={styles.btnContainer}>
                            <DynamicButton theme="yellow" onClick={() => setIsOpen(true)}>Create New Coupon</DynamicButton>
                        </div>
                    </div>
                    <DynamicTableFilters
                        componentName={"Platform-Generated Coupons"}
                        onApply={handleApply}
                        onClear={handleClear}
                    />
                    <div className={styles.tableWrapper}>
                        <DynamicDatatable
                            data={platformGeneratedTableData}
                            columns={columns}
                            type="gray"
                            pagination
                            highlightOnHover
                            responsive
                        />
                    </div>
                </div>
            ) : (
                <CouponCreationForm setIsOpen={setIsOpen} />
            )}
        </div>
    );
};

export default PlatformGeneratedCoupons;